import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { FormsModule } from '@angular/forms';
import { NgClass, NgStyle } from '@angular/common';
import { ByWordPipe } from '@shared/filters/by-word/by-word.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';

@Component({
    selector: 'button-with-text-menu-arrow',
    templateUrl: './button-with-text-menu-arrow.component.html',
    standalone: true,
    imports: [
      AfTranslatePipe,
      SpanTooltipComponent,
      AfTranslateDirective,
      OverlayPanelModule,
      FormsModule,
      NgClass,
      NgStyle,
      ByWordPipe,
      AfOrderByPipe
    ]
})
export class ButtonWithTextMenuArrowComponent implements OnChanges, AfterViewInit {
  buttonWithTextMenu: any = {
    inputFilter: '',
    textButton: '',
    widthButton: '200px'
  }
  @Input() item : any = {};
  @Input() selectedOption : any;
  @Input() list : any = [];
  @Input() multiline : number = 1;
  @Input() disabled : boolean = false;
  @Output() launchActionEmitter = new EventEmitter();
  @ViewChild(OverlayPanel) overlayPanelTextArrowMenu: OverlayPanel;
  @ViewChild('buttonTextArrowMenu') buttonTextArrowMenuElement: ElementRef;
  constructor(private dropdownsOpenFactory: DropdownsOpenFactory,
    private commonUtilsService: CommonUtilsService) { }

  ngOnChanges(): void {
    if(this.disabled){
      this.item.typeButton = 'disabled';
    }else{
      this.item.typeButton = this.item.type?this.item.type:'dark';
    }
    
    this.buttonWithTextMenu.smallButton = this.item.typeButton.indexOf('little') !== -1;
    this.buttonWithTextMenu.widthButton = this.item.maxWidth?this.item.maxWidth:'200px';
    if(this.selectedOption){
      this.buttonWithTextMenu.textButton = this.item.selectedString?this.selectedOption:this.selectedOption[this.item.keyName];
    }
  }

  ngAfterViewInit(): void {
    // if(!this.item.overlayInner){
      let typeOverlay: string = this.item.overlayInner?'overlayInner':'overlay';
      this.commonUtilsService.bindScrollOverlayListener(this.overlayPanelTextArrowMenu, typeOverlay);
      // this.commonUtilsService.bindScrollOverlayListener(this.overlayPanelTextArrowMenu);
    // }
  }

  resetFilter(){
    this.buttonWithTextMenu.inputFilter = '';
  }

  launchAction(action:any, optionAction:any, e: any){
    this.launchActionEmitter.emit({action: action, option: optionAction});
    this.selectedOption = optionAction;
     this.buttonWithTextMenu.textButton = this.item.selectedString?this.selectedOption:this.selectedOption[this.item.keyName];
    if(this.item.overlayInner){
      e.stopPropagation();
      this.dropdownsOpenFactory.closeLastDropdown();
    }else{
      this.dropdownsOpenFactory.closeDropdown();
    }
  }

  toggleFilter(e: any){
    let typeOverlay: string = this.item.overlayInner?'overlayInner':'overlay';
    this.commonUtilsService.toggleFilterOverlay(e, this.overlayPanelTextArrowMenu, typeOverlay);
  }
}
